module.exports = __webpack_public_path__ + "img/Logo_CIE_ID.c9fae7d0.svg";